import type { InstitutionTheme } from '../types';
import { csueastbayColors } from './colors';

// CSU East Bay institutional theme (W56 S3).
//
// Brand strings from the 2026-2027 catalog (catoid 44) + the brand site;
// "MyCSUEB" is the PeopleSoft student portal (class schedule, registration),
// verified on www.csueastbay.edu (class-schedule and winter-registration pages,
// W56 S0). Colors per ./colors.ts (PMS 199 Red + Black).
//
// Example course codes vetted against the S0 course index (2,735 codes):
// CS 101 (Computer Science I — primary), ENGL 300W (Writing for Inquiry — the
// W suffix marks a University Writing Requirement course), ANTH 110L
// (Laboratory in Biological Anthropology — the lab suffix). First is primary.
export const csueastbayTheme: InstitutionTheme = {
  slug: 'csueastbay',
  universityName: 'California State University, East Bay',
  universityShortName: 'Cal State East Bay',
  registrationPortalName: 'MyCSUEB',
  exampleCourseCodes: ['CS 101', 'ENGL 300W', 'ANTH 110L'],
  colors: csueastbayColors,
};
